'use strict';
import * as _ from 'lodash';
import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {LocalStorage} from "../wrappers/LocalStorage";

@Injectable()
export class LoginProvider {
    loggedInSubject = new Subject();

    constructor(private localStorage: LocalStorage) { }

    isLoggedIn() {
        return !_.isEmpty(this.localStorage.retrieve('user'));
    }

    loggedIn() {     
        this.loggedInSubject.next();
    }
    
    logInObserver() {  
        return this.loggedInSubject.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/login.provider.ts